"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = void 0;
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _styledComponents.ThemeProvider;
  }
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _index = require("../../_nextgen/components/Compare/components/Filters/index.styled");
var _IconLibrary = require("../../packages/IconLibrary");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _DynamicHeading = require("../DynamicHeading");
var _GlobalScrollbar = require("../GlobalScrollbar");
var _LexusTypography = require("../LexusTypography");
var _Typography = require("../Typography");
const GlobalStyle = exports.GlobalStyle = (0, _styledComponents.createGlobalStyle)`
  body {
    scroll-snap-align: start;
    scroll-snap-stop: normal;
  }
`;
var _default = exports.default = {
  PageNavigation: _styledComponents.default.div`
    color: #000;
    background-color: #fff;
    position: relative;
    top: 0;
    z-index: 4;
    display: flex;
    transition: background 0.3s;
    border-bottom: 1px solid #e2e2e2;
    min-height: 60px;
    svg {
      fill: #000;
    }
  `,
  Container: _styledComponents.default.div`
    position: relative;
    padding: ${function (_ref) {
    let {
      theme
    } = _ref;
    return theme.selectedUnderlineColor ? "0 20px" : "10px 20px";
  }};
    ${function (_ref2) {
    let {
      theme
    } = _ref2;
    return theme.selectedUnderlineColor && "max-width: 1280px";
  }};
    width: 100%;
    display: block;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    align-self: center;
    ${function (_ref3) {
    let {
      theme
    } = _ref3;
    return theme.mode === "Stacked" ? "flex-direction: column;" : "flex-direction: row; align-items: center;";
  }}
    ${(0, _breakpoints.default)("tablet", "down")} {
      ${function (_ref4) {
    let {
      theme
    } = _ref4;
    return theme.mode !== "Stacked" && "padding: 15px 0;";
  }}
    }
  `,
  Left: _styledComponents.default.div`
    display: flex;
    flex-direction: row;
    padding-left: ${function (_ref5) {
    let {
      noTitle
    } = _ref5;
    return noTitle && "20px";
  }};
  `,
  Right: _styledComponents.default.button`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-left: 20px;
    margin-right: 20px;
    background: transparent;
    border: none;
    min-height: 18px;
    padding: 0;
  `,
  RightContainer: _styledComponents.default.div`
    width: 100%;
    margin-right: 20px;
    ${(0, _breakpoints.default)("desktop", "up")} {
      ${function (_ref6) {
    let {
      theme
    } = _ref6;
    return !theme.selectedUnderlineColor && `
          flex-shrink: 1;
          overflow-x: hidden;
        `;
  }}
    }
  `,
  Model: (0, _styledComponents.default)(_DynamicHeading.DynamicHeading).attrs({
    defaultLevel: 2
  })`
    ${(0, _LexusTypography.nobel)({
    sizing: "heading24",
    weight: "bold"
  })}
    display: inline-block;
    margin: 0;
    line-height: 29px;
    white-space: nowrap;
    ${function (_ref7) {
    let {
      theme
    } = _ref7;
    return theme.mode !== "Stacked" && `
        border-right: 2px solid;
        padding: 0 20px;
        border-color: inherit`;
  }}
    ${(0, _breakpoints.default)("tablet", "down")} {
      line-height: 18px;
      margin-right: 20px;
      ${function (_ref8) {
    let {
      theme
    } = _ref8;
    return theme.mode === "Stacked" && `
        padding: 0;
        font-size: 11px;
        line-height: 14px;
        font-family: 'nobel-book';`;
  }}
    }
    ${(0, _breakpoints.default)("desktop", "up")} {
      padding: ${function (_ref9) {
    let {
      theme
    } = _ref9;
    return theme.selectedUnderlineColor ? "0 20px 0 0;" : "0 20px 0 20px";
  }};
      line-height: 1;
      ${function (_ref10) {
    let {
      theme
    } = _ref10;
    return theme.selectedUnderlineColor && "margin-right: 15px;";
  }}
    }

    button {
      border: none;
      color: inherit;
      cursor: pointer;
      line-height: inherit;
      padding: 0;
    }
  `,
  ModelButton: _styledComponents.default.a`
    text-decoration: none;
    cursor: pointer;
    color: inherit;
  `,
  LinksScrollWrapper: (0, _styledComponents.default)(_index.ScrollWrapper)`
    ${(0, _breakpoints.default)("desktop", "up")} {
      a {
        font-family: nobel-bold !important;
        font-size: 11px !important;
        line-height: 14px !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .LeftArrow {
        &[disabled] svg {
          display: none;
        }
      }
      .RightArrow {
        &[disabled] svg {
          display: none;
        }
      }
    }
  `,
  Links: _styledComponents.default.ul`
    position: relative;
    padding: 0;
    margin: 0;
    ${(0, _breakpoints.default)("desktop", "up")} {
      display: ${function (_ref11) {
    let {
      theme
    } = _ref11;
    return theme.selectedUnderlineColor ? "flex" : "inline-block";
  }};
    }
    ${(0, _breakpoints.default)("tablet", "down")} {
      ${function (_ref12) {
    let {
      theme
    } = _ref12;
    return theme.hasCta && "margin-bottom: 20px;";
  }};
    }
  `,
  LinkItemUnderline: _styledComponents.default.li`
    list-style: none;
  `,
  LinkItem: _styledComponents.default.li`
    list-style: none;
    &:after {
      content: "";
      width: 0;
      height: ${function (_ref13) {
    let {
      theme
    } = _ref13;
    return theme.selectedUnderlineColor ? "3px" : "1px";
  }};
      position: absolute;
      bottom: 0;
      left: 50%;
    }

    ${function (_ref14) {
    let {
      active
    } = _ref14;
    return active && `
      &:after {
        content: '';
        width: 100%;
        height: ${function (_ref15) {
      let {
        theme
      } = _ref15;
      return theme.selectedUnderlineColor ? "3px" : "1px";
    }};
        position: absolute;
        bottom: 0;
        left: 0;
      }
    `;
  }}

    ${(0, _breakpoints.default)("tablet", "down")} {
      ${function (_ref16) {
    let {
      active
    } = _ref16;
    return active && `
        position: relative;
        &:after {
          content: '';
          width: 3px;
          height: 100%;
          display: block;
          left: 0;
          top: 0;
          position: absolute;
        }
      `;
  }}
    }

    ${(0, _breakpoints.default)("desktop", "up")} {
      display: ${function (_ref17) {
    let {
      theme
    } = _ref17;
    return theme.selectedUnderlineColor ? "flex" : "inline-block";
  }};
      margin-left: ${function (_ref18) {
    let {
      theme
    } = _ref18;
    return theme.selectedUnderlineColor ? "0" : "29.5px";
  }};
      position: relative;
      &:hover {
        &:after {
          content: "";
          width: 100%;
          height: ${function (_ref19) {
    let {
      theme
    } = _ref19;
    return theme.selectedUnderlineColor ? "3px" : "1px";
  }};

          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  `,
  Link: (0, _Typography.StyledType)("a", {
    size: "linkCopy3",
    family: "nobel-bold"
  })`
    text-decoration: none;
    color: inherit;
    ${function (_ref20) {
    let {
      theme
    } = _ref20;
    return theme.selectedUnderlineColor ? "padding: 23px 15px;" : "";
  }}
    ${(0, _breakpoints.default)("tablet", "down")} {
      padding: 17px 20px;
      display: block;
      font-size: 13px;
      line-height: 14px
      ${function (_ref21) {
    let {
      active
    } = _ref21;
    return active && `
        background: #d9d9d9;
        position: relative;
        border-top: 1px solid #ededed;
        border-bottom: 1px solid #ededed;
        &:after {
          content: '';
          width: 3px;
          height: 100%;
          background: #b6a171;
          display: block;
          left: 0;
          top: 0;
          position: absolute;
        }
      `;
  }}
    }
  `,
  ButtonLink: _styledComponents.default.button``,
  Underline: _styledComponents.default.div`
    position: absolute;
    bottom: 0;
    background: #000;
    height: 1px;
    width: 0;
    left: 0;
  `,
  Button: _styledComponents.default.div`
    text-align: center;
    margin-bottom: 10px;
    white-space: nowrap;
    ${(0, _breakpoints.default)("desktop", "up")} {
      display: inline-block;
      margin-bottom: 0;
      margin-left: 15px;
      padding: ${function (_ref22) {
    let {
      theme
    } = _ref22;
    return theme.selectedUnderlineColor ? "0" : "0 20px 0 0";
  }};
    }

    a {
      font-size: 13px;
      height: 50px;
      margin: auto;
      max-width: 220px;
      min-width: initial;
      width: 100%;

      ${(0, _breakpoints.default)("desktop", "up")} {
        height: 40px;
        padding: 0 21.5px;
      }
    }
  `,
  SectionName: (0, _Typography.StyledType)("div", {
    size: "linkCopy1",
    family: "nobel-bold"
  })`
    text-align: left;
  `,
  DropDown: _styledComponents.default.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    ${function (props) {
    return props.isOpen ? "max-height: 100vh;" : "max-height: 0;";
  }};
    transition-property: max-height;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
    overflow: auto;
    z-index: 1;
    ${_GlobalScrollbar.scrollbarStyle}
  `,
  DropdownButton: _styledComponents.default.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 25px;
  `,
  DropdownArrow: (0, _styledComponents.default)(_IconLibrary.Arrow)`
    width: 15px;
    transition: transform 0.3s;
    transform: rotateX(
      ${function (_ref23) {
    let {
      isDropdownOpen
    } = _ref23;
    return isDropdownOpen ? "0.5turn" : "0turn";
  }}
    );
  `,
  ButtonList: _styledComponents.default.div`
    margin-bottom: 35px;
  `,
  Backdrop: _styledComponents.default.div`
    width: 100%;
    height: 100vh;
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    z-index: 0;
  `
};